import { autoinject, bindable } from 'aurelia-framework';
import { DeleteDialogService } from './../../services/delete-dialog-service';
import { AsyncErrorHandler } from 'lib/ui';
import { FileAttachment } from 'models';
import { saveAs } from 'file-saver';
import { AttachmentHandler } from 'services/attachments';
import { PdfPreviewController } from 'elements/pdf-preview-controller';

@autoinject()
export class Attachments {
  @bindable
  public simple: boolean;

  @bindable
  public disabled: boolean;

  @bindable
  public onlyRead: boolean;

  @bindable
  public handler: AttachmentHandler;
  handlerChanged() {
    void this.getMetadata();
  }

  // TODO: Implement this
  // Should delete the file then upload the new one...
  // @bindable
  // public single: boolean = true;

  protected isIos: boolean = false;
  protected cameraInput: HTMLInputElement;

  protected selectedFile: File | undefined;
  protected selectedFileName: string | undefined;

  private files: FileAttachment[] = [];

  constructor(private deleteDialogService: DeleteDialogService, private pdfPreviewController: PdfPreviewController) {}

  attached() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);

    if (this.handler) {
      void this.getMetadata();
    }
  }

  protected async onFileSelected(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    await this.upload(file);
  }

  openCamera(): void {
    this.cameraInput?.click();
  }

  @AsyncErrorHandler
  private async getMetadata() {
    const files = await this.handler.metadata();
    this.files = files.map((file) => {
      const filenameLength = file.FileName.length;

      if (filenameLength > 31) {
        const f1 = file.FileName.slice(0, 14);
        const f2 = file.FileName.slice(filenameLength - 14);
        file['TrimmedName'] = `${f1}...${f2}`;
      }

      file['isPdf'] = file.FileName?.endsWith('.pdf');
      return file;
    });
  }

  @AsyncErrorHandler
  protected async preview(file: FileAttachment) {
    const res = await this.handler.download(file.Id);
    void this.pdfPreviewController.openPdfPreview(res);
  }

  @AsyncErrorHandler
  async save(file: FileAttachment) {
    const res = await this.handler.download(file.Id);
    saveAs(res.blob, res.fileName);
  }

  @AsyncErrorHandler
  async deleteFile(file: { Id: string | number }) {
    await this.deleteDialogService.confirmBeforeDelete(async () => {
      await this.handler.delete(file.Id);
    });
    this.files = this.files.filter((x) => x.Id !== file.Id);
  }

  @AsyncErrorHandler
  async upload(file: File) {
    this.selectedFileName = file.name;
    await this.handler.upload(file);
    this.selectedFile = undefined;
    await this.getMetadata();
  }
}
